var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { Component, Children, cloneElement } from "react";
import { v4 } from "uuid";
import MenuList from "./MenuList";
import { Container } from "./styled/menu";

var Menu =
/** @class */
function (_super) {
  __extends(Menu, _super);

  function Menu() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.idRef = v4();
    _this.state = {
      isOpen: false,
      focusIndex: -1,
      direction: null,
      forceClose: false
    };

    _this.handleOnScroll = function () {
      if (!_this.state.isOpen) return;

      _this.handleOnClose();
    };

    _this.handleOnOpen = function (direction) {
      _this.setState({
        isOpen: true,
        direction: direction
      });
    };

    _this.handleOnClose = function (forceClose) {
      if (forceClose === void 0) {
        forceClose = false;
      }

      _this.setState({
        isOpen: false,
        focusIndex: -1,
        forceClose: forceClose
      });
    };

    _this.handleOnToggle = function () {
      if (!_this.state.isOpen) {
        _this.handleOnOpen("manual");
      } else {
        _this.handleOnClose();
      }
    };

    _this.handleSetFocusIndex = function (focusIndex) {
      _this.setState({
        focusIndex: focusIndex
      });
    };

    return _this;
  }

  Menu.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        props = __rest(_a, ["children"]);

    return React.createElement(Container, __assign({}, props), Children.map(this.props.children, function (child) {
      // Using `any` here as I'm not sure how to target forwardRef components.
      // styled components will use forward ref so we have to drill into `el.type.target`
      var el = child;

      if ((el.type === MenuList || el.type.target && el.type.target === MenuList) && !_this.state.isOpen) {
        return;
      }

      return cloneElement(el, __assign(__assign({}, _this.state), {
        idRef: _this.idRef,
        onToggle: _this.handleOnToggle,
        onOpen: _this.handleOnOpen,
        onClose: _this.handleOnClose,
        setFocusIndex: _this.handleSetFocusIndex
      }));
    }));
  };

  Menu.prototype.componentDidMount = function () {
    window.addEventListener("scroll", this.handleOnScroll);
  };

  Menu.prototype.componentWillUnmount = function () {
    window.removeEventListener("scroll", this.handleOnScroll);
  };

  return Menu;
}(Component);

export default Menu;